import {useEnabledFeatures} from '../../../hooks/use-enabled-features'
import {usePaginatedMemexItemsQuery} from './use-paginated-memex-items-query'

export function usePaginatedTotalCount() {
  const {memex_table_without_limits} = useEnabledFeatures()
  if (!memex_table_without_limits) return 0
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {queriesForItems, queriesForGroups} = usePaginatedMemexItemsQuery()

  let totalCount = 0
  // The total count of all the items matching the view filter is different for grouped and ungrouped views. For grouped
  // views, that value is present in the group-level queries, for ungrouped views, it is present in the item-level queries.
  // In both cases, all pages in the query have the same value for totalCount, so we just use the first query.
  if (queriesForGroups.length > 0) {
    totalCount = queriesForGroups[0]?.data?.totalCount.value ?? 0
  } else {
    totalCount = queriesForItems[0]?.data?.totalCount.value ?? 0
  }
  return totalCount
}
